'use client';

import React from 'react';
import SoldOutBadge from '@/components/SoldOutBadge';
import { getAvailability, type Product } from '@/lib/products';
import { useI18n } from '@/i18n/LocaleProvider';

interface AvailabilityBadgeProps {
  product: Product;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function AvailabilityBadge({ product, size = 'md', className = '' }: AvailabilityBadgeProps) {
  const { t } = useI18n();
  const availability = getAvailability(product);
  if (availability === 'sold_out') return <SoldOutBadge size={size} className={className} />;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-xs px-3 py-1',
    lg: 'text-sm px-4 py-1.5',
  };
  const colors =
    availability === 'preorder'
      ? 'text-accent border-accent bg-accent/10'
      : 'text-emerald-500 border-emerald-500 bg-emerald-500/10';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border-2 font-bold tracking-widest uppercase ${colors} ${sizeClasses[size]} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {availability === 'preorder' ? t.shop.preorder : t.shop.inStock}
    </span>
  );
}
